export default __webpack_public_path__ + "static/media/blackjack.fd69b6a3.jpg";